import { ChangeArticlesType } from 'containers/InsightPage/InsightPage.types';
import { InsightArticleType } from 'utils/sharedStrapiQueries/sharedTypes';

export const getInsightTypeFromParam = param => {
  switch (param) {
    case 'eventPages':
      return 'eventPages';
    case 'news':
      return 'newsArticles';
    case 'insights':
      return 'insightsArticles';
    case 'awards':
      return 'awardPages';
    default:
      return '';
  }
};

export const getFollowingArticles = (
  pages: Array<InsightArticleType>,
  current: InsightArticleType
): ChangeArticlesType => {
  const currentPageIndex = pages.findIndex(item => item.slug === current.slug);

  const nextPage = pages[currentPageIndex + 1];
  const prevPage = pages[currentPageIndex - 1];

  return {
    prevArticle: prevPage
      ? pages[currentPageIndex - 1]
      : pages[pages.length - 1],
    nextArticle: nextPage ? pages[currentPageIndex + 1] : pages[0],
  };
};
